<div class="display-flex gap-12">
  <div class="display-flex vertical gap-12">
    <div class="statistics-item-container">
      @if (myQuestsCount.isLoading()) {
        <ngx-skeleton-loader class="loader" count="1" appearance="line" size="48" [theme]="{height: '42px'}" />
      } @else {
        <div class="bold-48">
          {{myQuestsCount.value()}}
        </div>
      }
      <div class="semibold-14 secondary-text-color">
        {{'myQuests' | transloco}}
      </div>
    </div>
    <div class="statistics-item-container">
      @if (myPublicQuestsCount.isLoading()) {
        <ngx-skeleton-loader class="loader" count="1" appearance="line" size="48" [theme]="{height: '42px'}" />
      } @else {
        <div class="bold-48">
          {{myPublicQuestsCount.value()}}
        </div>
      }
      <div class="semibold-14 secondary-text-color">
        {{'myPublicQuests' | transloco}}
      </div>
    </div>

    <div class="display-flex gap-12">
      <div class="statistics-item-container width-fit-content">
        @if (countMyQuestsStartedCompleted.isLoading()) {
          <ngx-skeleton-loader class="loader" count="1" appearance="line" size="48" [theme]="{height: '42px'}" />
        } @else {
          <div class="bold-48" [ngStyle]="{color: 'var(' + completionPercentageColor() + ')'}">
            {{completionPercentage()}}%
          </div>
        }
        <div class="semibold-14 secondary-text-color">
          {{'myQuestsCompletionPercentage' | transloco}}
        </div>
      </div>
      <div class="statistics-item-container width-fit-content justify-center" style="gap: 0">
        @if (countMyQuestsStartedCompleted.isLoading()) {
          <ngx-skeleton-loader class="loader" count="1" appearance="line" size="24" [theme]="{height: '21px'}" />
        } @else {
          <div class="display-flex flex-align-end gap-4">
            <div class="bold-24">
              {{countMyQuestsStartedCompleted.value()['completed']}}
            </div>
            <div class="semibold-14 secondary-text-color" style="padding-bottom: 5px">{{'completed' | transloco}}</div>
          </div>
        }
        <div class="semibold-14 secondary-text-color">{{('from2' | transloco).toLowerCase()}}</div>
        @if (countMyQuestsStartedCompleted.isLoading()) {
          <ngx-skeleton-loader class="loader" count="1" appearance="line" size="24" [theme]="{height: '21px'}" />
        } @else {
          <div class="display-flex flex-align-end gap-4">
            <div class="bold-24">
              {{countMyQuestsStartedCompleted.value()['started']}}
            </div>
            <div class="semibold-14 secondary-text-color"  style="padding-bottom: 5px">{{'startedPT' | transloco}}</div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="statistics-item-container">
    <div class="semibold-16 secondary-text-color">{{'questsCompletionGraph' | transloco}}</div>
    <canvas id="quests-progress-chart" class="full-width" style="max-height: 400px"></canvas>
  </div>
</div>


<div class="display-flex gap-12 margin-top-24">
  <div class="statistics-item-container">
    <div class="semibold-16 secondary-text-color">{{'placesVisitsGraph' | transloco}}</div>
    <canvas id="obelisks-progress-chart" class="full-width" style="max-height: 400px"></canvas>
  </div>
  <div class="display-flex vertical gap-12">
    <div class="statistics-item-container">
      @if (countMyObelisks.isLoading()) {
        <ngx-skeleton-loader class="loader" count="1" appearance="line" size="48" [theme]="{height: '42px'}" />
      } @else {
        <div class="bold-48">
          {{countMyObelisks.value()}}
        </div>
      }
      <div class="semibold-14 secondary-text-color">
        {{'myPlaces' | transloco}}
      </div>
    </div>
    <div class="statistics-item-container">
      @if (countMyApprovedObelisks.isLoading()) {
        <ngx-skeleton-loader class="loader" count="1" appearance="line" size="48" [theme]="{height: '42px'}" />
      } @else {
        <div class="bold-48">
          {{countMyApprovedObelisks.value()}}
        </div>
      }
      <div class="semibold-14 secondary-text-color">
        {{'myApprovedPlaces' | transloco}}
      </div>
    </div>
  </div>
</div>
